import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fb",
  "use": "fb-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"fb\"><path fill-rule=\"evenodd\" d=\"M16.3 25v-9.231h3.313l.496-3.75H16.3V9.625c0-1.086.31-1.825 1.906-1.825l2.037-.001V4.445c-.352-.046-1.56-.148-2.968-.148-2.936 0-4.947 1.748-4.947 4.957v2.765H9.007v3.75h3.321V25H4.375a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v17a4 4 0 0 1-4 4H16.3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol